import {createContext} from "react";
import SimpleQRCode from "../../../../../api/qr-code/SimpleQRCode";

type QRCodeViewItemContextType = {
    /**
     * QR code.
     * @author Kacper Faber
     * @since 0.1.8
     */
    qrCode: SimpleQRCode | undefined;

    delete: () => Promise<void>;
};

/**
 * Default value.
 * @author Kacper Faber
 * @since 0.1.8
 */
const defaults: QRCodeViewItemContextType = {
    qrCode: undefined,
    delete: () => { throw new Error('not implemented'); }
};

/**
 * QR code context
 * @author Kacper Faber
 * @since 0.1.8
 */
const ctx = createContext<QRCodeViewItemContextType>(defaults);

export default ctx;